import {
  addEmployeeToCustomDefinitionApi,
  deleteEmployeeFromCustomDefinitionApi,
  createCustomDefinitionApi,
  deleteCustomDefinitionApi,
  getCustomDefinitionDetailsApi,
  getCustomDefinitionListApi,
  updateCustomDefinitionApi,
} from 'api/customDefinition';

export const getCustomDefinitionList = ({ offset, limit, isAdminRoleRequired = true }) =>
  getCustomDefinitionListApi({ offset, limit, isAdminRoleRequired }).then((res) => res.entity ?? []);

export const getCustomDefinitionDetails = ({ id }) => getCustomDefinitionDetailsApi({ id }).then((res) => res.entity);

export const createCustomDefinition = (customDefinitionObj) =>
  createCustomDefinitionApi(customDefinitionObj).then((res) => res.entity);

export const updateCustomDefinition = ({ id, customDefinitionObj }) =>
  updateCustomDefinitionApi({ id, customDefinitionObj }).then((res) => res.entity);

export const deleteCustomDefinition = ({ id }) => deleteCustomDefinitionApi({ id });

export const addEmployeeToCustomDefinition = ({ customDefinitionId, empIds }) =>
  addEmployeeToCustomDefinitionApi({ customDefinitionId, empIds }).then((res) => res.entity);

export const deleteEmployeeFromCustomDefinition = ({ customDefinitionId, empId }) =>
  deleteEmployeeFromCustomDefinitionApi({ customDefinitionId, empId }).then((res) => res.entity);
